import {AbstractContainer} from "/modules/common/timeseries/AbstractContainer";
import * as $ from "jquery";
import Plotly from 'plotly.js-dist-min';
import '/modules/extended_report/css/timeseries/land-climate-classification.css';
import '/modules/extended_report/css/timeseries/land-climate-classification.responsive.css';
import '/modules/extended_report/css/timeseries/land-climate-classification.mobile.css';
import {Loader} from "../../common/ui/Loader";
import {formatNumber} from "../../common/util";
import {formatDate} from "../../common/time/TimeCalculator";
import {Dropdown, DropdownOption} from "../../common/ui/Dropdown";
import {RadioButtonsSet} from "../../common/ui/RadioButtonsSet";

/**
 * A container for displaying land and climate data for a point
 * @extends AbstractContainer
 */
class LandAndClimateClassificationContainer extends AbstractContainer {

    /**
     *
     * @param id {string} The HTML id for this container
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param regionalClassGDORDRIAStatsUrl {string}
     * @param statsDescUrl {string}
     * @param rdriaChartStyler {ChartStyler} A chart styler for RDrIA indicator
     **/
    constructor(id, translator, isMobileDevice, runtimeConfig, regionalClassGDORDRIAStatsUrl, statsDescUrl, rdriaChartStyler) {
        super(id, translator, isMobileDevice, runtimeConfig);
        this.regionalClassGDORDRIAStatsUrl = regionalClassGDORDRIAStatsUrl;
        this.statsDescUrl = statsDescUrl;
        this.rdriaChartStyler = rdriaChartStyler;
    }

    getClassName() {
        return "LandAndClimateClassificationContainer";
    }

    RDRIA_VALUES = ["3", "2", "1"];

    isExpanded() {
        return this.getSessionProp("expanded") === true;
    }

    getContainerElement() {
        if (!this.containerElement) {
            const expanded = this.isExpanded();

            const faoLandClassificationOptions = [
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.luo', 'luo'),
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.lvo', 'lvo'),
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.ppo', 'ppo'),
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.sto', 'sto'),
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.tmo', 'tmo'),
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.ifo', 'ifo'),
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.iro', 'iro'),
                new DropdownOption(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.gwo', 'gwo')
            ];
            this.faoLandClassificationDropdown = new Dropdown(this.translator, this.isMobileDevice, this.id + '_fao_land_classifications', faoLandClassificationOptions, faoLandClassificationOptions[0].getValue(), true, undefined, (dropdown) => {
                this._updateLand();
            });

            const values = this.RDRIA_VALUES.slice(),
                labels = this.RDRIA_VALUES.map(value=>
                    '<div class="color" style="background-color: '+this.rdriaChartStyler.getColorFunction()(value)+'"></div>'+this.rdriaChartStyler.getLabelFunction()(value)
                );
            this.faoRdriaRadioSet = new RadioButtonsSet(
                this.translator, this.isMobileDevice, this.id + '_fao_rdria', values, labels, values[0], true, (radioSet) => {
                    this._updateLand();
                }
            );

            this.containerElement = $(
                '<div class="land-climate-classification container ' + (expanded ? 'expanded' : '') + '">' +
                '   <div class="header" role="heading">' +
                '       <div class="title">' +
                '           <h3>' + this.translator.translate('tool.charts.landAndClimateClassification.name') + '</h3>' +
                '       </div>' +
                '       <div class="buttons-container">' +
                '           <button class="expander ' + (expanded ? 'collapse' : 'expand') + '" type="button" title="' + this.translator.translate('tool.charts.expander') + '"></button>' +
                '       </div>' +
                '   </div>' +
                '   <div class="body" aria-expanded="' + expanded + '">' +
                '       <div class="stats climate">' +
                '           <table class="values climate">' +
                '               <thead>' +
                '                   <tr>' +
                '                       <th>' + this.translator.translate('tool.charts.landAndClimateClassification.stats.climateType') + '</th>' +
                '                       <th class="value rdria-' + this.RDRIA_VALUES[0] + '"><div class="color" style="background-color: '+this.rdriaChartStyler.getColorFunction()(this.RDRIA_VALUES[0])+'"></div>' +this.rdriaChartStyler.getLabelFunction()(this.RDRIA_VALUES[0])+'</th>' +
                '                       <th class="value rdria-' + this.RDRIA_VALUES[1] + '"><div class="color" style="background-color: '+this.rdriaChartStyler.getColorFunction()(this.RDRIA_VALUES[1])+'"></div>' +this.rdriaChartStyler.getLabelFunction()(this.RDRIA_VALUES[1])+'</th>' +
                '                       <th class="value rdria-' + this.RDRIA_VALUES[2] + '"><div class="color" style="background-color: '+this.rdriaChartStyler.getColorFunction()(this.RDRIA_VALUES[2])+'"></div>' +this.rdriaChartStyler.getLabelFunction()(this.RDRIA_VALUES[2])+'</th>' +
                '                   </tr>' +
                '               </thead>' +
                '               <tbody>' +
                '               </tbody>' +
                '           </table>' +
                '       </div>' +
                '      <div class="column land">' +
                '           <div class="stats land">' +
                '               <div class="fao-classifier-selector-container"></div>' +
                '               <div class="affected-areas-selector-container"></div>' +
                '               <table class="values land">' +
                '                   <thead>' +
                '                       <tr>' +
                '                           <th class="classification">' + this.translator.translate('tool.charts.landAndClimateClassification.stats.landClassification')+ ' - ' +this.translator.translate('tool.charts.landAndClimateClassification.stats.faoLandClassification.' + this.faoLandClassificationDropdown.getValue()) + '</th>' +
                '                           <th class="value">' + this.translator.translate('tool.charts.landAndClimateClassification.stats.area') + '</th>' +
                '                       </tr>' +
                '                   </thead>' +
                '                   <tbody>' +
                '                   </tbody>' +
                '               </table>' +
                '           </div>' +
                '       </div>' +
                '       <div class="column land">' +
                '           <div class="chart"></div>' +
                '       </div>' +
                '   </div>' +
                '</div>'
            );


            $('.fao-classifier-selector-container', this.containerElement).append(this.faoLandClassificationDropdown.getUIElement());
            $('.affected-areas-selector-container', this.containerElement).append(this.faoRdriaRadioSet.getUIElement());
            this.loader = new Loader("report_land_class_loader", this.isMobileDevice, $('.body', this.containerElement));
            this.loader.show();
        }
        return this.containerElement;
    }

    updateDateAruId(date, aruId) {
        this.loader.show();
        if (aruId)
            this.aruId = aruId;
        if (date)
            this.refDate = date;

        const onGetData = fCol => {
            const fao = [], koppen = [], koppenAreas = [], faoAreas = [];

            if (fCol.features) {
                Object.keys(fCol.features[0].properties.alerts.famine).sort().forEach(f => {
                    const famineElement = fCol.features[0].properties.alerts.famine[f];
                    fao[Number(f)] = famineElement.summary.fao;
                    faoAreas[Number(f)] = famineElement.area;
                    koppen[Number(f)] = famineElement.summary.koppen;
                    koppenAreas[Number(f)] = famineElement.area;
                });
            }
            this.fao = fao;
            this.faoAreas = faoAreas;
            this.koppen = koppen;
            this.koppenAreas = koppenAreas;

            const rdriaFromServer = Object.keys(fCol.features[0].properties.alerts.famine);
            const rdriaNotFromServer = this.RDRIA_VALUES.filter(v => rdriaFromServer.indexOf(v) < 0);
            this.faoRdriaRadioSet.disableValues(rdriaNotFromServer)
            this.faoRdriaRadioSet.setValue(this.faoRdriaRadioSet.getPossibleValues()[0]);

            this._updateLand();

            this._updateClimate();
            $('.body .stats.climate table.values.climate th, .body .stats.climate table.values.climate td', this.uiElement).show();
            rdriaNotFromServer.forEach(value => $('.body .stats.climate table.values.climate th.rdria-' + value + ', .body .stats.climate table.values.climate td.rdria-' + value, this.uiElement).hide());

            this.loader.hide();
        }

        $.getJSON(this.regionalClassGDORDRIAStatsUrl.format([this.aruId, formatDate(this.refDate)]), (fCol) => {
            if (!this.luts) {
                $.ajax({
                    dataType: "jsonp",
                    url: this.statsDescUrl,
                    jsonp: "callback",
                    success: luts=>{
                        this.luts = luts;
                        onGetData(fCol);
                    }
                });
            } else onGetData(fCol);
        });
    }

    _updateLand() {
        const classification = this.faoLandClassificationDropdown.getValue();

        $('.stats.land th.classification', this.uiElement).html(
            this.translator.translate('tool.charts.landAndClimateClassification.stats.landClassification')
            +' - '+
            this.translator.translate('tool.charts.landAndClimateClassification.stats.faoLandClassification.' + classification)
        );

        const rdria = this.faoRdriaRadioSet.getValue();
        const totalArea = this.faoAreas[rdria];
        const tbody = $('.body .stats.land table.values.land tbody', this.uiElement).empty();
        const chartTarget = $('.body .column.land .chart', this.uiElement).empty();
        const table = {}, chartData = {type:'pie',sort:false,hole:.4,labels:[],values:[],marker:{colors:[]}, hovertemplate:"%{label} (%{value}%)<extra></extra>"};

        if (this.fao[rdria] && this.fao[rdria][classification]) {
            Object.keys(this.fao[rdria][classification]).forEach(key => {
                const values = this.fao[rdria][classification][key];
                const perc = values.area/totalArea*100;
                table[key] = {area: values.area, name: values.title, perc: perc}
                chartData.labels.push(values.title);
                chartData.values.push(Number(perc.toFixed(1)));
                const color = 'rgb('+this.luts.fao[classification][key].color.join(',')+')';
                chartData.marker.colors.push(color);
            });

            const config = {
                responsive: true,
                showSendToCloud: false,
                modeBarButtonsToRemove: ['select2d', 'lasso2d', 'zoomIn2d', 'zoomOut2d', 'resetScale2d'],
                modebarStyle: {
                    orientation: this.isMobileDevice ? 'v' : 'h'
                }
            }
            const layout = {
                autosize: true,
                margin: {
                    l: 35,
                    r: 35,
                    b: 15,
                    t: 15,
                    pad: 2
                },
                paper_bgcolor: "rgba(0,0,0,0)",
                plot_bgcolor: "rgba(0,0,0,0)",
                textposition: 'outside',
                showlegend: false
            }

            Plotly.newPlot(chartTarget[0], [chartData], layout, config);
        } else {
            chartTarget.append($('<div>').html(this.translator.translate('tool.charts.landAndClimateClassification.noDrought',[
                this.translator.translate('tool.charts.landAndClimateClassification.stats.faoLandClassification.' + classification),
                this.rdriaChartStyler.getLabelFunction()(rdria)
            ])).addClass('no-drought'))
        }

        Object.keys(table)
            .sort((k1, k2) => Number(k1) - Number(k2))
            .forEach((key) => {
                const values = table[key];
                const tr = $('<tr></tr>');
                const color = 'rgb('+this.luts.fao[classification][key].color.join(',')+')';
                tr.append($('<td><div class="color-key"><div class="color" style="background-color: '+color+'"></div>' + key + '</div>' + values.name + '</td>'));
                tr.append($('<td class="value">' + formatNumber(values.area / 1000) + ' <span class="context">(' + formatNumber(values.perc, 1) + '%)</span>' + '</td>'));
                tbody.append(tr);
            });

    }

    _updateClimate() {
        const tbody = $('.body .stats.climate table.values.climate tbody', this.uiElement).empty();
        const table = {};
        this.koppen.forEach((elem, idx) => {
            Object.keys(elem).forEach(key => {
                const values = elem[key];
                if (!table[key]) {
                    table[key] = {name: values.title};
                }
                table[key]["" + idx] = {area: values.area, totalArea: this.koppenAreas[idx]}
            });
        });

        Object.keys(table)
            .sort((e1, e2) => table[e2].name.localeCompare(table[e1].name))
            .forEach(climateType => {
                const element = table[climateType];
                const color = 'rgb('+this.luts.koppen[climateType].color.join(',')+')';

                const tds = [$('<td><div class="color" style="background-color: '+color+'"></div>' + element.name + '</td>')].concat(this.RDRIA_VALUES.slice().map(value => {
                    const valueArea = element[value] ? element[value].area : 0;
                    const totalArea = element[value] ? element[value].totalArea : 1;
                    return $('<td class="value rdria-' + value + '">' + formatNumber(valueArea / 1000000, 2) + 'km<sup>2</sup> <span class="context">(' + formatNumber(valueArea / totalArea * 100, 1) + '%)</span></td>')
                }));
                const tr = $('<tr></tr>');
                tds.forEach(td => tr.append(td));
                tbody.append(tr);
            });
    }

}

export {LandAndClimateClassificationContainer}